// extracted by mini-css-extract-plugin
export var rotate = "Transition-module--rotate--acfb9";
export var transition = "Transition-module--transition--45eb7";